import React, { Component } from 'react';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import { closeBag, updateLine, removeLine } from '../redux/actions/bagActions';
import { track } from '../analytics';

function money(amount) {
	const n = Number(amount);
	return isNaN(n) ? '$0.00' : '$' + n.toFixed(2);
}

class CartDrawer extends Component {
	constructor(props) {
		super(props);
		this.checkout = this.checkout.bind(this);
	}

	checkout() {
		const { checkoutUrl, subtotal, totalQuantity } = this.props;
		if (!checkoutUrl) return;
		track('begin_checkout', {
			value: Number(subtotal || 0).toFixed(2),
			currency: 'USD',
			items: totalQuantity,
		});
		window.location.href = checkoutUrl;
	}

	render() {
		const { lines, subtotal, isOpen, loading, closeBag, updateLine, removeLine } = this.props;

		return (
			<Drawer anchor="right" open={isOpen} onClose={closeBag} className="nf-cart-drawer">
				<div className="nf-cart">
					<header className="nf-cart-head">
						<span className="nf-eyebrow">Your bag</span>
						<button type="button" className="nf-cart-x" onClick={closeBag} aria-label="Close bag">
							&times;
						</button>
					</header>

					{lines.length === 0 ? (
						<div className="nf-cart-empty">Your bag is empty.</div>
					) : (
						<ul className="nf-cart-items">
							{lines.map((l) => (
								<li className="nf-cart-item" key={l.lineId}>
									<div className="nf-cart-thumb">{l.image && <img src={l.image} alt={l.title} />}</div>
									<div className="nf-cart-info">
										<span className="nf-cart-title">{l.title}</span>
										{l.variantTitle && <span className="nf-cart-variant">{l.variantTitle}</span>}
										<span className="nf-cart-price">{money(l.price)}</span>
										<div className="nf-qty">
											<button type="button" disabled={loading} onClick={() => updateLine(l.lineId, l.qty - 1)} aria-label="Decrease quantity">&minus;</button>
											<span>{l.qty}</span>
											<button type="button" disabled={loading} onClick={() => updateLine(l.lineId, l.qty + 1)} aria-label="Increase quantity">+</button>
											<button type="button" className="nf-cart-remove" disabled={loading} onClick={() => removeLine(l.lineId)}>Remove</button>
										</div>
									</div>
								</li>
							))}
						</ul>
					)}

					<footer className="nf-cart-foot">
						<div className="nf-cart-subtotal">
							<span>Subtotal</span>
							<span className="nf-cart-subtotal-val">{money(subtotal)}</span>
						</div>
						<p className="nf-cart-note">Shipping &amp; taxes calculated at checkout.</p>
						<button
							type="button"
							className="nf-btn nf-cart-checkout"
							disabled={lines.length === 0 || loading}
							onClick={this.checkout}
						>
							{loading ? 'Updating…' : 'Checkout'}
						</button>
					</footer>
				</div>
			</Drawer>
		);
	}
}

const mapStateToProps = (state) => ({
	lines: state.bag.lines,
	subtotal: state.bag.subtotal,
	checkoutUrl: state.bag.checkoutUrl,
	totalQuantity: state.bag.totalQuantity,
	isOpen: state.bag.isOpen,
	loading: state.bag.loading,
});

const mapDispatchToProps = (dispatch) => ({
	closeBag: () => dispatch(closeBag()),
	updateLine: (lineId, qty) => dispatch(updateLine(lineId, qty)),
	removeLine: (lineId) => dispatch(removeLine(lineId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartDrawer);
